import React from "react";
import {
  Modal,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const FileUploadResultModal = ({ responseData, isOpen, onClose }) => {
  return (
    <Modal open={isOpen} > 
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#FFF",
          padding: "20px",
          borderRadius: "4px",
          minWidth: "300px",
        }}
      >
        {" "}
        <Typography variant="h6">Upload Result</Typography>
        <div
          style={{
            backgroundColor: "#FFF",

            maxHeight: "300px",
            overflowY: "scroll",
          }}
        >
          <List>
            <ListItem key="total">
              Total Trainings:
              <ListItemText
                sx={{ paddingLeft: "16px" }}
                primary={JSON.stringify(responseData.total)}
              ></ListItemText>
            </ListItem>
            <ListItem key="success">
              Success :
              <ListItemText
                sx={{ paddingLeft: "16px" }}
                primary={JSON.stringify(responseData.success)}
              ></ListItemText>
            </ListItem>
            <ListItem key="failed">
              Failed :
              <ListItemText
                sx={{ paddingLeft: "16px" }}
                primary={JSON.stringify(responseData.failed)}
              ></ListItemText>
            </ListItem>
          </List>
          {responseData.errors.length > 0 && (
            <div>
              <Typography variant="h6" sx={{ color: "red" }}>
                Errors :
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Traning Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Traning Email
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          First Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Last Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Traning Type
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Error Message
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {responseData.errors.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.trainingName}</TableCell>
                        <TableCell>{item.traineeEmail}</TableCell>
                        <TableCell>{item.traineeFirstName}</TableCell>
                        <TableCell>{item.traineeLastName}</TableCell>
                        <TableCell>{item.trainingType}</TableCell>
                        <TableCell>
                          <Typography variant="body1" sx={{ color: "red" }}>
                            {item.msg}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
        <Button
          id="upload-trainings-ok-button"
          variant="contained"
          onClick={onClose}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default FileUploadResultModal;
